import { BetHistory, BetHistoryDetail } from "src/models/bet-history.model";
import { formatDateTime } from "./date-format.function";

// Utility function for grouping objects by a key
export function groupArrByKey<T>(list: T[], key: keyof T): Record<string, T[]> {
  return list.reduce((acc, item) => {
    const groupKey = String(item[key]);
    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }
    acc[groupKey].push(item);
    return acc;
  }, {} as Record<string, T[]>);
}

export function BetHistoryFormater(list: any[]): BetHistory[] {
  return list.map((entry) => {
    const { meeting_name, total_winnings, race_name,  total_stake, details, date, ...others} = entry;
    let newDetails: BetHistoryDetail[] = details.map((d: any) => {
      const { formule_complet, combinations_num, winnings_type, ...others} = d;
      return {
        ...others,
        formuleComplet: formule_complet,
        combinations: combinations_num,
        winningsType: winnings_type,
      };
    })

    return {
      ...others,
      totalStake: total_stake,
      meetingName: meeting_name,
      raceName: race_name,
      date: formatDateTime(date),
      totalWinnings: total_winnings,
      details: newDetails
    }
  })
}
